// PATH: src/api/curriculum.ts — choix « programme marocain ou non » et import
// du référentiel (tc_tilmischool_be). Lecture : tout compte de l'école ;
// choix et import : direction uniquement (403 sinon).
import { useMemo } from "react";
import { useApiClient } from "./apiClients";

const BASE = "/api/v1/school/curriculum";

/** "" = l'établissement n'a pas encore choisi (onboarding à faire). */
export type CurriculumMode = "" | "MA" | "CUSTOM";

export interface Curriculum {
  mode: CurriculumMode;
  embed_program_id?: string;
  chosen_at?: string;
}

/** Un niveau du catalogue : sans filière, ou niveau + filière. */
export interface CurriculumSelection {
  grade_id: string;
  track_id?: string;
}

export interface CurriculumImportResult {
  mode: CurriculumMode;
  levels_created: number;
  levels_adopted: number;
  levels_existing: number;
  subjects_created: number;
  subjects_adopted: number;
  links_created: number;
  warnings: string[];
}

export const useCurriculumApi = () => {
  const http = useApiClient("tilmischool");

  return useMemo(
    () => ({
      get: () => http.get<Curriculum>(BASE).then((r) => r.data),
      // L'import lit tout le catalogue côté serveur avant d'écrire : on lui
      // laisse plus que le délai par défaut.
      apply: (body: { mode: "MA" | "CUSTOM"; selections?: CurriculumSelection[] }) =>
        http
          .post<CurriculumImportResult>(BASE, body, { timeout: 2 * 60 * 1000 })
          .then((r) => ({ ...r.data, warnings: r.data.warnings ?? [] })),
    }),
    [http]
  );
};
